<ion-app>
  <ion-split-pane contentId="main-content" when="(max-width: 1px)">
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
